module.exports = __webpack_public_path__ + "9488d02b/img/lock-icon.bb9c7166.svg";